"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var mask_1 = require("./interface/mask");
var CnpjPipe = /** @class */ (function (_super) {
    __extends(CnpjPipe, _super);
    function CnpjPipe() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CnpjPipe.prototype.rebuildMaskAfterBackspace = function (text) {
        if (this.lastDeletedChar === '.' || this.lastDeletedChar === '/' || this.lastDeletedChar === '-') {
            text = text.slice(0, -1) + this.lastDeletedChar + text.slice(-1);
            this.lastDeletedChar = null;
        }
        return text;
    };
    CnpjPipe.prototype.addEspecialCharToCorrectLengthText = function (text) {
        if (text.length === 2 || text.length === 6) {
            text = text + '.';
        }
        else if (text.length === 10) {
            text = text + '/';
        }
        else if (text.length === 15) {
            text = text + '-';
        }
        return text;
    };
    return CnpjPipe;
}(mask_1.Mask));
exports.CnpjPipe = CnpjPipe;
//# sourceMappingURL=cnpj.pipe.js.map


// WEBPACK FOOTER //
// cnpj.pipe.js